import { render, staticRenderFns } from "./svg-caret-left.vue?vue&type=template&id=4aaeaeda&"
import script from "./svg-caret-left.vue?vue&type=script&lang=js&"
export * from "./svg-caret-left.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports